export enum TimeRangeUnitType {
  Days = 0,
  Months = 1,
  Years = 2,
  Weeks = 3,
  Hours = 4,
}